export class NeqDatePickerModel {
    from: Date;
    to: Date;
}